import { render, staticRenderFns } from "./BtSendgridEmail.vue?vue&type=template&id=6dbe5c5d&"
import script from "./BtSendgridEmail.vue?vue&type=script&lang=js&"
export * from "./BtSendgridEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports